import {
  Badge as ChakraBadge,
  BadgeProps as ChakraBadgeProps,
} from '@chakra-ui/react';

// @doc https://chakra-ui.com/docs/components/data-display/badge
export type BadgeProps = ChakraBadgeProps;
export const Badge = ChakraBadge;
